<template>
  <div class="tannin-chart">
    <line-chart :data="chartData" height="100%" :library="options"/>
  </div>
</template>

<script>
import moment from 'moment';

export default{
  props: ['view_type', 'samples', 'levels'],
  data() {
    return {
      moment,
    };
  },
  computed: {
    options() {
      return {
        tooltips: {
          callbacks: {
            title: (tooltipItem, data) => {
              let d = data.labels[tooltipItem[0].index];
              return moment(d).format('MMM DD YYYY');
            },
          },
        },
        scales: {
          xAxes: [{
            time: {
              unit: 'day',
              minUnit: 'day',
              displayFormats: {
                day: 'MMM D YYYY',
              },
              min: this.samples[0].sample_date.split('-')[0] + '-09-1',
              max: this.samples[0].sample_date.split('-')[0] + '-12-10',
            },
          }],
        },
      };
    },
    chartData() {
      const skinData = [];
      const seedData = [];
      this.samples.forEach((sample) => {
        const day = sample.sample_date.split('-')[2];
        const month = sample.sample_date.split('-')[1];
        const year = sample.sample_date.split('-')[0];
        const newDate = new Date(year, month - 1, day, 12, 0, 0);
        if (newDate >= new Date(year, 8, 10) && newDate <= new Date(year, 11, 15)) {
          skinData.push([newDate, sample.skin_tannin]);
          seedData.push([newDate, sample.seed_tannin]);
        }
      });
      switch (this.view_type) {
        case 'skin':
          return [
            { name: 'Skin', data: skinData },
          ];
        case 'seed':
          return [
            { name: 'Seed', data: seedData },
          ];
        default:
          return [
            { name: 'Skin', data: skinData },
            { name: 'Seed', data: seedData },
          ];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .tannin-chart{
    background: #f1f1f1;
    margin-top: 0.5rem;
    padding: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/TanninChart.vue